/**
 * No-op console when STRINGPAK_DEBUG_CONSOLE is not set.
 * Babel also strips console.* from the bundle (babel.config.js); this catches
 * third-party scripts and any code not passed through Babel.
 */
const noop = () => {};
let DEBUG = false;
try {
  DEBUG =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('STRINGPAK_DEBUG_CONSOLE') === '1';
} catch {
  DEBUG = false;
}

if (!DEBUG && typeof console !== 'undefined') {
  (console as any).log = noop;
  (console as any).warn = noop;
  (console as any).error = noop;
  (console as any).info = noop;
  (console as any).debug = noop;
}
